import {
  Table,
  TableHead,
  TableBody,
  TableTR,
  TableTH,
  TableTD
} from './elements';

const CustomTable = ({ children }) => {
  return <Table>{children}</Table>;
};

const HEADER_BG = '#F3F4F6';
const ROW_BORDER = '#E5E7EB';

CustomTable.Thead = ({ children }) => {
  return (
    <TableHead bg={HEADER_BG}>
      {children}
    </TableHead>
  );
};

CustomTable.Tbody = ({ children, h }) => {
  return <TableBody h={h}>{children}</TableBody>;
};

CustomTable.TR = ({ children, bg }) => {
  return (
    <TableTR bg={bg} style={{ borderBottom: `1px solid ${ROW_BORDER}` }}>
      {children}
    </TableTR>
  );
};

CustomTable.TH = ({ children, fixed, minWidth }) => {
  return (
    <TableTH fixed={fixed} minWidth={minWidth} bg={HEADER_BG}>
      {children}
    </TableTH>
  );
};

CustomTable.TD = ({ children, fixed, bg }) => {
  return (
    <TableTD fixed={fixed} bg={bg}>
      {children}
    </TableTD>
  );
};

export default CustomTable;
